import userCategoriesPromoThresholdsHtml from './userCategoriesPromoThresholds.html';

class userCategoriesPromoThresholdsController {
    constructor($scope, $http, $timeout, ModalService, translateService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.$timeout = $timeout;
        this.modalService = ModalService;
        this.translate = translateService;

        this.loading = true;
        this.error = false;
        this.success = false;

        this.userCategoryId = null;
        this.userCategory = null;

        this.shopId = null;
        this.shopName = null;
        this.editable = true;

        $scope.$watch(() => this.userCategoryId, (newVal, oldVal) => {
            if (newVal === null) {
                return;
            }

            this.init();
        });
    }

    init() {
        this.$http.post('/admpanel/ajax/users/getUserCategory', {user_category_id: this.userCategoryId}, {
            headers: {'Content-Type': 'application/json'}
        }).then(
            (response) => {
                this.loading = false;
                this.editable = response.data.editable;
                if (response.data.status === 'error') {
                    this.error = response.data.message;
                    $('html, body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.error = false;
                        window.location.pathname = 'admpanel/users/categories';
                    }, 5000);
                } else {
                    this.userCategory = response.data.user_category;
                    this.shopName = response.data.shop_name;
                }
            },
            () => {
                this.loading = false;

                this.error = this.translate.t('admpanel.general.unexpectedErrorHasOccurred');
                $('html, body').animate({ scrollTop: 0 }, 'slow');

                this.$timeout(() => {
                    this.error = false;
                    window.location.pathname = 'admpanel/users/categories';
                }, 5000);
            }
        );
    }

    addPromoThreshold() {
        this.userCategory.promo_thresholds.push({
            id: null,
            user_category_id: null,
            name: '',
            amount_from: Math.max(...this.userCategory.promo_thresholds.filter(o => o.deleted_at === false).map(o => o.amount_from), 0) + 1000,
            value: Math.max(...this.userCategory.promo_thresholds.filter(o => o.deleted_at === false).map(o => o.value), 0) + 5,
            deleted_at: false
        });
    }

    removePromoThreshold(promoThreshold) {
        const index = this.userCategory.promo_thresholds.indexOf(promoThreshold);

        if (index !== -1) {
            this.userCategory.promo_thresholds[index].deleted_at = true;
        }
    }

    restorePromoThreshold(promoThreshold) {
        const index = this.userCategory.promo_thresholds.indexOf(promoThreshold);

        if (index !== -1) {
            this.userCategory.promo_thresholds[index].deleted_at = false;
        }
    }

    savePromoThresholds() {
        this.loading = true;

        this.$http.post('/admpanel/ajax/users/savePromoThresholds', {user_category: this.userCategory}, {
            headers: {'Content-Type': 'application/json'}
        }).then(
            (response) => {
                this.loading = false;
                if (response.data.status === 'error') {
                    this.error = response.data.message;
                    $('html, body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.error = false;
                        window.location.pathname = 'admpanel/users/categories';
                    }, 5000);
                } else {
                    this.success = 'Progi rabatowe kategorii klientów "' + this.userCategory.name + '" zostały zapisane.';
                    $('html, body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);
                }
            },
            () => {
                this.loading = false;

                this.error = this.translate.t('admpanel.general.unexpectedErrorHasOccurred');
                $('html, body').animate({ scrollTop: 0 }, 'slow');

                this.$timeout(() => {
                    this.error = false;
                    window.location.pathname = 'admpanel/users/categories';
                }, 5000);
            }
        );
    }
}

let userCategoriesPromoThresholdsComponent = {
    bindings: {
        'shopId': '<',
        'userCategoryId': '<'
    },
    template: userCategoriesPromoThresholdsHtml,
    controller: userCategoriesPromoThresholdsController
};

export default userCategoriesPromoThresholdsComponent;
